import type { ResponseEnvelope } from '#layers/base/public';
import { useSystemFetch } from '#layers/base/public';

/** Raw API functions for creating API keys through the custom system endpoint. */

export interface CreateApiKeyPayload {
	userId: string;
	name: string;
	ttl: string | null;
	description?: string;
}

export interface CreateApiKeyResponse {
	id: string;
	key: string;
}

/**
 * Create an API key.
 *
 * @returns The created key ID and the secret token (only returned once)
 */
export async function createApiKey(payload: CreateApiKeyPayload): Promise<CreateApiKeyResponse> {
	const fetch = useSystemFetch();

	const { data } = await fetch<ResponseEnvelope<CreateApiKeyResponse>>('system/api-keys', {
		method: 'POST',
		body: payload,
	});

	return data;
}
